document.addEventListener("DOMContentLoaded", function () { 
  document.querySelectorAll(".favorite_prod_main").forEach(function (favSection) {
    const productSwiperEl = favSection.querySelector(".fav_prod_product_swiper");
    const testiSwiperEl = favSection.querySelector(".fav_prod_testi_swiper");
    const mediaSwiperEl = favSection.querySelector(".fav_prod_media_swiper");
    const prevBtn = favSection.querySelector(".fav_prod_testi_prev");
    const nextBtn = favSection.querySelector(".fav_prod_testi_next");
    const pagination = favSection.querySelector(".fav_prod_testi_pagination");

    if (!productSwiperEl || !testiSwiperEl || !mediaSwiperEl) return;

    const productSwiper = new Swiper(productSwiperEl, {
      slidesPerView: 1,
      loop: false,
      effect: "fade",
      autoHeight: true,
      fadeEffect: {
        crossFade: true
      },
    });

    const testiSwiper = new Swiper(testiSwiperEl, {
      slidesPerView: 1,
      loop: false,
      pagination: {
        el: pagination,
        type: "fraction",
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });

    const mediaSwiper = new Swiper(mediaSwiperEl, {
      slidesPerView: 1,
      loop: false,
    });

    // Manually sync slide change events
    productSwiper.on('slideChange', function () {
      testiSwiper.slideTo(productSwiper.activeIndex);
      mediaSwiper.slideTo(productSwiper.activeIndex);
    });

    testiSwiper.on('slideChange', function () {
      productSwiper.slideTo(testiSwiper.activeIndex);
      mediaSwiper.slideTo(testiSwiper.activeIndex);
    });

    mediaSwiper.on('slideChange', function () {
      productSwiper.slideTo(mediaSwiper.activeIndex);
      testiSwiper.slideTo(mediaSwiper.activeIndex);
    });
  });
});
